import HomePages from '../Home/HomePages';

export default class HomeUnivers extends HomePages {
  constructor() {
    super();
  }
}

new HomeUnivers();
